import React from "react";

import { ProductCard } from "app/compare/ProductCard";
import { Technical } from "app/compare/Technical";
import { Winner } from "app/compare/Winner";
import { ComparedModel } from "app/compare/[match]";

import { ComparatorWinner } from "./ComparatorHelper";

type Props = {
  left?: ComparedModel;
  right?: ComparedModel;
  winner?: ComparatorWinner;
};

export const CompareProducts = ({ left, right, winner }: Props) => {
  if (!left || !right) {
    return null;
  }

  return (
    <>
      <section className="flex gap-5 justify-center mx-auto w-full max-w-[950px] sm:!gap-28 2xs:gap-16">
        <ProductCard product={left.product} />
        <ProductCard product={right.product} />
      </section>

      <Winner left={left} right={right} winner={winner} />
      <Technical left={left} right={right} />
    </>
  );
};
